import { FC } from "react";
import image from "../../Assets/homev2/tod-image.png";
import ContainedButton from "./Buttons/Contained";

const TalentOnDemand: FC = () => {
  return (
    <div className="w-full h-full bg-black flex flex-col items-center justify-between gap-4 pt-8 md:pt-20 ">
      <div className="px-4 lg:px-0">
        <h2 className="text-2xl md:text-5xl xl:text-7xl text-white font-semibold text-center flex items-start justify-center">
          Talent OnDemand
          <span className="text-xl md:text-3xl font-normal">&#8482;</span>
        </h2>
        <h4 className="text-center w-full mx-auto md:mx-0 md:w-fit text-white md:text-2xl mt-4">
          Sales & tech experts. <br className="md:hidden" /> Hand-selected for
          your team.
        </h4>
        <a
          href="/talent-ondemand"
          className="block mx-auto w-full max-w-[180px] md:max-w-max py-4 md:mt-10 md:w-max"
        >
          <ContainedButton>Get started</ContainedButton>
        </a>
      </div>
      <div>
        <img
          src={image}
          alt="3 people standing together"
          width="100%"
          height="100%"
          loading="lazy"
        />
      </div>
    </div>
  );
};

export default TalentOnDemand;
